import React from 'react'
import RequestForm from './RequestForm'
import RequestListItem from './RequestListItem'
import './styles.css'
import { db } from '../../Components/Firebase/firebase.config'
import Alert from '@mui/material/Alert';
import {addDoc, collection, serverTimestamp, doc, getDocs, setDoc, query, onSnapshot} from 'firebase/firestore'
import Loader from '../../Components/Loader/Loader'
import { UserContext } from '../../Context/context';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';


const RequestCourse = () => {
  const {user, setUser} = React.useContext(UserContext)
  const [listLoading, setListLoading] = React.useState(false)
  const [DATA, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false);
  const [votes, setVotes] = React.useState(false)

  React.useEffect(() => {
    (async function() {
      setListLoading(true);
      const querySnapshot = await getDocs(collection(db, "request"));
      let data = []
      querySnapshot.forEach((doc) => {
        data = [...data, {id: doc.id, ...doc.data()}]
      });
      setData(data);
      setListLoading(false)
    })();
    
  }, [loading, votes])
  
  return (
    <>
    {loading===false && <div>
      <RequestForm setLoading={setLoading}/>
      <div className="requestList">
        {listLoading && <Box sx={{ height: '100%',display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress color="success" />
    </Box>}
        {listLoading===false && DATA.length<1 && <div style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
          <Alert variant="filled" sx={{width: '80%'}} severity="info">No course request Available!!</Alert>
        </div>}
      {DATA.map(item=><RequestListItem user={user} key={item.id} data={item} setVotes={setVotes}/>
      )}
      </div>
      </div>}
      {loading && <Loader/>}
    </>
  )
}

export default RequestCourse